<script>
import { orderTypes } from "@/store/types/types.js";
import * as moment from "moment";
export default {
  name: "Barcode",
  data() {
    return {
      targetKeys: [],
      name: "",
      targetId: "",
      year: "",
      month: "",
      date: ""
    };
  },
  methods: {
    editBag(id) {
      this.$store
        .dispatch(orderTypes.actions.EDIT_BAG, Number(id))
        .then(res => {
          this.targetKeys = [];
          this.name = res.name;
          let date = res.delivered_at.split("-");
          this.year = date[0];
          this.month = date[1];
          this.date = date[2];
          return;
        })
        .then(() => {
          this.$jquery("#successModal").modal("show");
          this.targetId = "";
          this.$refs["input"].focus();
        })
        .catch(() => {
          this.$jquery("#errorModal").modal("show");
          this.targetId = "";
          this.$refs["input"].focus();
          this.targetKeys = [];
        });
    },
    arrangeASCIICode() {
      // let asciiCode = this.targetKeys.reduce((acc, cur) => {
      //   return acc + cur;
      // }, "");

      // let asciiCodeArr = asciiCode
      //   .split("Alt")
      //   .filter(code => code !== "")
      //   .map(code => Number(code));
      // let orderId = String.fromCharCode(...asciiCodeArr);
      if (!this.targetId) {
        this.$jquery("#errorModal").modal("hide");
        this.$jquery("#successModal").modal("hide");
        return;
      }
      this.editBag(this.targetId);
    },
    scanBarCode(key) {
      key.key === "Enter" ? this.arrangeASCIICode() : null;
      this.targetKeys.push(key.key);
    }
  },
  mounted() {
    this.$refs["input"].focus();
  }
};
</script>


<template src="./template.html"></template>
<style lang="scss" src="./style.scss" scoped />
